import { NotificationType } from "app/notifications/model/notification.model";

interface AlertTypeIconProps {
    notificationType: NotificationType,
    isOn?: boolean;
    className?: string;
    border?: boolean;
}

const defaultProps: AlertTypeIconProps = {
    isOn: false,
    notificationType: NotificationType.Info,
    className: '',
    border: true
}

export function AlertTypeIcon(props: AlertTypeIconProps = defaultProps) {

    const background = (color: string) => props.isOn ? `bg-${color}` : '';
    const fontColor = (color: string) => props.isOn ? `text-white` : `text-${color}`;
    const border = (color: string) => props.border ? `border border-${color}` : '';

    const notificationTypeParse = {
        [NotificationType.Success]: (
            <span className={`symbol-label ${background('success')} ${border('success')} d-flex align-items-center justify-content-center ${props.className}`}>
                <i className={`fa-solid fa-circle-check ${fontColor('success')}`}></i>
            </span>
        ),
        [NotificationType.Error]: (
            <span className={`symbol-label ${background('danger')} ${border('danger')} d-flex align-items-center justify-content-center ${props.className}`}>
                <i className={`fa-solid fa-triangle-exclamation ${fontColor('danger')}`}></i>
            </span>
        ),
        [NotificationType.Warning]: (
            <span className={`symbol-label ${background('warning')} ${border('warning')} d-flex align-items-center justify-content-center ${props.className}`}>
                <i className={`fa-solid fa-exclamation ${fontColor('warning')}`}></i>
            </span>
        ),
        [NotificationType.Info]: (
            <span className={`symbol-label ${background('primary')} ${border('primary')} d-flex align-items-center justify-content-center ${props.className}`}>
                <i className={`fa-solid fa-circle-info ${fontColor('primary')}`}></i>
            </span>
        ),
    };

    return (notificationTypeParse[props.notificationType]);
}